import { OnboardingRequestStepName } from '../stepTypes';

const basePath = `/myoffice/supplier-onboarding-dashboard/onboarding`;
export enum OnboardingSectionPaths {
  DashbordBase = 'myoffice/supplier-onboarding-dashboard/onboarding',
  SupplierOnboardingDashboardRequestsSent = basePath,
  SupplierOnboardingDashboardRequestsReceived = `${basePath}/requests-received`,
  Dashboard = `${basePath}/:tab?`,
  Main = `${basePath}/:requestId/:step`
}

// Utility function for generating onboarding step paths
export const getOnboardingStepPath = (
  requestId: string,
  step: OnboardingRequestStepName
): string => {
  return OnboardingSectionPaths.Main.replace(':requestId', requestId).replace(
    ':step',
    step
  );
};
